import { BaseChildReduxAction } from '../../redux/models/base-child-redux-action';

export class SelectedLayerInfo extends BaseChildReduxAction {
  layerId: string;
  layerType: string;
  step: Date;
  scenarioId: string;
  snapshotId: string;
  startDate: Date;
  endDate: Date;
  mapId: string;
  elementId: string;
  latLng: { lat: string; lng: string };

  public get key(): string {
    return `${this.snapshotId}-${this.scenarioId}`;
  }

  constructor(init: Partial<SelectedLayerInfo>) {
    super(init);
    Object.assign(this, init);
  }
}
